import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// ---------- Global active-request counter so the AppShell can show a progress bar ----------
let _active = 0;
const _listeners = new Set();
function _notify() {
    for (const fn of _listeners) {
        try { fn(_active); } catch (e) { void e; }
    }
}
export function subscribeApiLoading(fn) {
    _listeners.add(fn);
    fn(_active);
    return () => _listeners.delete(fn);
}

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("wl_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (!config.__silent) {
        _active += 1;
        _notify();
    }
    return config;
});

api.interceptors.response.use(
    (r) => {
        if (!r.config?.__silent) {
            _active = Math.max(0, _active - 1);
            _notify();
        }
        return r;
    },
    (err) => {
        if (!err.config?.__silent) {
            _active = Math.max(0, _active - 1);
            _notify();
        }
        if (
            err.response?.status === 401 &&
            !window.location.pathname.startsWith("/login")
        ) {
            localStorage.removeItem("wl_token");
            window.location.href = "/login";
        }
        return Promise.reject(err);
    },
);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) =>
                e && typeof e.msg === "string" ? e.msg : JSON.stringify(e),
            )
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
